import { render, staticRenderFns } from "./TestDetails.vue?vue&type=template&id=7af2c63c&scoped=true"
import script from "./TestDetails.vue?vue&type=script&lang=js"
export * from "./TestDetails.vue?vue&type=script&lang=js"
import style0 from "./TestDetails.vue?vue&type=style&index=0&id=7af2c63c&prod&scoped=true&lang=css"
import style1 from "./TestDetails.vue?vue&type=style&index=1&id=7af2c63c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2c63c",
  null
  
)

export default component.exports